// extracted by mini-css-extract-plugin
export default {"socialProof":"socialProof__NTZjY","dek":"dek__NDBlY","tooltipContainer":"tooltipContainer__MDk0Z","tooltipIcon":"tooltipIcon__MWJiM"};